<template>
  <div class="grid-cols-8 gap-x-6 py-6">
    <div class="grid xl:col-start-1 xl:col-end-4">
      <Input v-model="search" placeholder="Search an Ad by keywords" />
    </div>
    <div class="grid xl:col-start-4 xl:col-end-6">
      <Select
        v-if="active_filters.industry"
        v-model="industry"
        placeholder="Industry"
        :options="industries"
      />
    </div>

    <div class="grid xl:col-start-6 xl:col-end-8">
      <Select
        v-model="is_ad"
        placeholder="Ads/Organic"
        :options="is_ad_options"
      />
    </div>
    <div v-if="active_filters.month" class="grid xl:col-start-8 xl:col-end-10">
      <Select v-model="month" placeholder="Months" :options="previous_months" />
    </div>
    <div class="col-start-1 col-end-3 pt-4 flex">
      <div
        v-for="(value, name) in {
          industry,
          is_ad,
          month,
        }"
        :key="`filter${value}`"
      >
        <span
          class="filters__item"
          v-if="value"
          @click="removeFilterOption(name)"
        >
          <Icon name="Check" class="check w-4 h-4 mr-2" />
          <Icon name="Close" class="close w-4 h-4 mr-2" />
          <p v-if="name == 'month'">
            {{
              value === "PREV_MONTH"
                ? "Previous months"
                : new Date(value).toLocaleString("en-us", {
                    month: "long",
                    year: "numeric",
                  })
            }}
          </p>
          <p v-else>
            {{ value }}
          </p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import { computed, watch, ref } from "vue";
import { useStore } from "vuex";
import Input from "@/components/UI/Input";
import Select from "@/components/UI/Select/index";
import Icon from "@/components/UI/Icon";
import moment from "moment";
import { useRouter } from "vue-router";
export default {
  components: { Input, Select, Icon },
  props: {
    "default-filters": Object,
    active_filters: Object,
    origin: String,
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const textFilters = ref("Yes");

    const search = computed({
      get() {
        if (props["origin"] === "tiktoks") {
          return store.state.filters_tiktoks.search;
        } else if (props["origin"] === "topbrands") {
          return store.state.filters_topBrands.search;
        } else {
          return store.state.filters.search;
        }
      },
      set(newValue) {
        let setTitle;
        if (props["origin"] === "tiktoks") {
          setTitle = "SET_FILTERS_PROPERTY_TIKTOKS";
        } else if (props["origin"] === "topbrands") {
          setTitle = "SET_FILTERS_PROPERTY_TOP_BRANDS";
        } else {
          setTitle = "SET_FILTERS_PROPERTY";
        }
        store.commit(setTitle, {
          key: "search",
          value: newValue,
        });
      },
    });

    const industry = computed({
      get() {
        return store.state.filters_tiktoks.industry;
      },
      set(newValue) {
        store.commit("SET_FILTERS_PROPERTY_TIKTOKS", {
          key: "industry",
          value: newValue,
        });
      },
    });

    const month = computed({
      get() {
        return store.state.filters_tiktoks.month;
      },
      set(newValue) {
        store.commit("SET_FILTERS_PROPERTY_TIKTOKS", {
          key: "month",
          value: newValue,
        });
      },
    });

    const is_ad = computed({
      get() {
        if (store.state.filters_tiktoks.is_ad == null) return null;
        return store.state.filters_tiktoks.is_ad ? "Organic Videos" : "Ads";
      },
      set(newValue) {
        store.commit("SET_FILTERS_PROPERTY_TIKTOKS", {
          key: "is_ad",
          value:
            newValue == null
              ? null
              : newValue == "All"
              ? null
              : newValue == "Ads"
              ? false
              : true,
        });
      },
    });

    const industries = computed(() => store.state.industries);
    const user = computed(() => store.state.user);
    const role = store.state.role;
    const PREV_MONTHS = (a) => {
      var dates = [];
      dates.push({
        value: new Date(),
        label: moment(new Date()).format("MMMM YYYY"),
      });
      for (let i = 0; i < a; i++) {
        var prev_month = new Date();

        prev_month.setMonth(prev_month.getMonth() - i, 0);

        dates.push({
          value: new Date(prev_month),
          label: moment(prev_month).format("MMMM YYYY"),
        });
      }
      dates.push({
        value: "PREV_MONTH",
        label: "Previous Months",
      });
      return dates;
    };

    const previous_months = PREV_MONTHS(2);

    // The values are invert because is the way easier for filter.
    const is_ad_options = computed(() => [
      { label: "Ads", value: "Ads" },
      { label: "Organic Videos", value: "Organic Videos" },
      { label: "All", value: "All" },
    ]);

    watch(
      search,
      debounce(() => {
        getTiktoks();
      }, 1500)
    );
    watch(month, () => {
      if (["monthly"].includes(role) && month.value == "PREV_MONTH") {
            console.log("1")

        router.push("/pricing");
      }
    });

    watch([industry, is_ad, month], () => {
      getTiktoks();
    });

    const getTiktoks = () => {
      store.commit("SET_PAGE_Tiktoks", 1);
      store.commit("SET_TIKTOKS", null);
      store.dispatch("GET_TIKTOKS", {
        addedFilters: null,
        idUser: user.value.id,
      });
    };

    const resetFilters = () => {
      search.value = null;
      store.commit("CLEAN_FILTERS");
      store.commit("SET_PAGE", 1);
      store.commit("SET_ADVERTISEMENTS", null);
      if (props["default-filters"]) {
        store.dispatch("GET_ADVERTISEMENTS", {
          addedFilters: props["default-filters"],
        });
      } else {
        store.dispatch("GET_ADVERTISEMENTS", { addedFilters: null });
      }
    };

    const removeFilterOption = (name) => {
      switch (name) {
        case "industry":
          industry.value = "";
          break;
        case "is_ad":
          is_ad.value = null;
          break;
        case "month":
          month.value = null;
          break;
        default:
          break;
      }
    };

    const toggleMoreFilters = () => {
      textFilters.value = !textFilters.value;
    };

    return {
      toggleMoreFilters,
      textFilters,
      search,
      industry,
      industries,
      getTiktoks,
      resetFilters,
      removeFilterOption,
      role,
      user,
      is_ad,
      is_ad_options,
      month,
      previous_months,
    };
  },
};
</script>

<style scoped>
.filters__item {
  @apply flex border-r border-gray-600 py-0 px-3 mr-2 cursor-pointer;
}
.filters__item svg {
  transition: 0.3s;
}
.filters__item:hover .check,
.filters__item .close {
  display: none;
}
.filters__item:hover .close {
  display: block;
}
.filters__item:hover .refresh {
  transform: rotate(60deg);
}
</style>
